import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { logout, getOrganizationName } from "../../store/actions/authAction";
import { refreshAll } from "../../store/actions/initAction";

import LogoWithVersion from "../../components/common/LogoWithVersion";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import withStyles from '@mui/styles/withStyles';
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import PersonPin from "@mui/icons-material/PersonPinRounded";
import HomeIcon from "@mui/icons-material/HomeRounded";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EnhancedEncryption from '@mui/icons-material/EnhancedEncryption';

import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import history from '../../history/history';
import { RefreshRounded } from "@mui/icons-material";
import { ListItemButton } from "@mui/material";
import AccountSwitcher from "../../components/common/AccountSwitcher";

const sanitizeOrganizationName = value => {
	if (typeof value !== "string") {
		return value;
	}

	const trimmed = value.trim().toLowerCase();
	if (trimmed.startsWith("<!doctype") || trimmed.startsWith("<html")) {
		return "";
	}

	return value;
};

const styles = theme => ({
	root: {
		width: "100%",
		display: 'flex',
	},
	grow: {
		flexGrow: 1
	},
	menuButton: {
		marginLeft: -12,
		marginRight: 20
	},
	title: {
		display: "none",
		[theme.breakpoints.up("sm")]: {
			display: "block"
		}
	},
	sectionDesktop: {
		display: "none",
		[theme.breakpoints.up("md")]: {
			display: "flex"
		}
	},
	sectionMobile: {
		display: "flex",
		[theme.breakpoints.up("md")]: {
			display: "none"
		}
	},
	button: {
		margin: theme.spacing(1)
	},
	
	  appBar: {
		zIndex: theme.zIndex.drawer + 1,
	  },
	  drawer: {
		width: drawerWidth,
		flexShrink: 0,
	  },
	  drawerPaper: {
		width: drawerWidth,
	  },
	  content: {
		flexGrow: 1,
		padding: theme.spacing(3),
	  },
	  toolbar: theme.mixins.toolbar,
	  list: {
		width: 250,
	  },
	  fullList: {
		width: 'auto',
	  },
});
const drawerWidth = 240;
class Header extends React.Component {
	state = {
		anchorEl: null,
		mobileMoreAnchorEl: null
	};

	componentDidMount() {
		if (this.props.isEmployee) {
			this.props.getOrganizationName();
		}
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.isEmployee && this.props.isEmployee) {
			this.props.getOrganizationName();
		}
	}

	handleProfileMenuOpen = event => {
		this.setState({ anchorEl: event.currentTarget });
	};

	handleMenuClose = () => {
		this.setState({ anchorEl: null });
		this.handleMobileMenuClose();
	};

	handleMobileMenuOpen = event => {
		this.setState({ mobileMoreAnchorEl: event.currentTarget });
	};

	handleMobileMenuClose = () => {
		this.setState({ mobileMoreAnchorEl: null });
	};
	goToHomePage = () => {
		console.log("GO TO MENU");
		let path = "/employee";
		history.push(path);
	}
	// refresh = () => {
	// 	this.props.refreshAll()
	// }
	render() {
		const { isEmployee, organizationName } = this.props;
		const { anchorEl, mobileMoreAnchorEl } = this.state;
		const { classes } = this.props;
		const isMenuOpen = Boolean(anchorEl);
		const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
		let commonLinks = [
			{ page: "home", default: "Accueil", icon:<HomeIcon />, to: "/employee" },
		];
		const guestLinks = [{ page: "login", default: "Login", icon:<PersonPin/>, to: "/login" }];
		const rawOrganizationName =
			typeof organizationName === "string"
				? organizationName
				: organizationName?.organization_name || "";
		const resolvedOrganizationName = sanitizeOrganizationName(rawOrganizationName);

		const displayOrganizationName = isEmployee
			? (resolvedOrganizationName && resolvedOrganizationName !== "" ? resolvedOrganizationName : "--")
			: "";

		const userMenu = (
			<Menu
				anchorEl={anchorEl}
				anchorOrigin={{ vertical: "top", horizontal: "right" }}
				transformOrigin={{ vertical: "top", horizontal: "right" }}
				open={isMenuOpen}
				onClose={this.handleMenuClose}
			>
				{/* {isEmployee &&
					<ListItemButton
						// component={Link}
						LinkComponent={Link}
						to="/employee/profile"
					>
						<ListItemText >
							Profile
						</ListItemText>
					</ListItemButton>


					// TO DO: CREATE A SPECIFIC PROFILE PAGE FOR EMPLOYEES
				} */}
				{isEmployee &&
					<ListItem
						onClick={() => {
							this.handleMenuClose();
							this.props.logout();
						}}
					>
						<ListItemText >
						Se Déconnecter
							
						</ListItemText>
					</ListItem>
				}			
				{!isEmployee &&
				<Link to={"/login"} >
					<ListItem>
						<ListItemText>
						Se Connecter							
						</ListItemText>
					</ListItem>
				</Link>
				}			
			</Menu>
		);

		return (
            <div className={classes.root}>
				<AppBar position="fixed" color="primary">
					<div className="max-view-width">
						<Toolbar>
							<div className={classes.sectionMobile}>
								<div style={{ display: "flex", alignItems: "center" }}>
									<LogoWithVersion onLogoClick={this.goToHomePage} />
									{isEmployee && (
										<Typography
											component="span"
											variant="subtitle2"
											style={{ marginLeft: "12px", fontWeight: 500, color: "#000" }}
										>
											{displayOrganizationName}
										</Typography>
									)}
								</div>
							</div>

							<div className={classes.sectionDesktop}>
								<div style={{ display: "flex", alignItems: "center" }}>
									<Typography
										className={classes.title}
										variant="h6"
										color="inherit"
										noWrap
									>
										<LogoWithVersion onLogoClick={this.goToHomePage} />
									</Typography>
									{isEmployee && (
										<Typography
											component="span"
											variant="subtitle1"
											style={{ marginLeft: "16px", fontWeight: 600, color: "#000" }}
										>
											{displayOrganizationName}
										</Typography>
									)}
								</div>
							</div>

							<div className={classes.grow} />
							
							<div>
								<Link className="" to="/">
									<IconButton size="large">
										<HomeIcon />
									</IconButton>
								</Link>
								{/* <IconButton onClick={this.refresh} color="inherit" size="large">
									<RefreshRounded />
								</IconButton> */}
								{isEmployee && <AccountSwitcher />}
								<IconButton
                                    aria-owns={
										isMenuOpen
											? "material-appbar"
											: undefined
									}
                                    aria-haspopup="true"
                                    onClick={this.handleProfileMenuOpen}
                                    color="inherit"
                                    size="large">
									<AccountCircle />
								</IconButton>
								
							</div>
							
						</Toolbar>
					</div>
				</AppBar>
				
				{userMenu}
			</div>
        );
	}
}

function mapStateToProps(state) {
	return {
		isEmployee: state.auth.isEmployee,
		organizationName: state.auth.organizationName,
	};
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			logout,
			getOrganizationName,
			// refreshAll,
		},
		dispatch
	);
}
Header.propTypes = {
	classes: PropTypes.object.isRequired
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withStyles(styles)(Header));
